import { faCircleNotch, faUndo } from '@fortawesome/free-solid-svg-icons'
import { Config } from 'final-form'
import { debounce } from 'lodash';

import { ReactiveVue } from "@skinsoft/reactive-vue";
import Component from "vue-class-component";
import { BarcodeReader, BarcodeSubscriber } from "../../barcode";
import { ItemCard } from "../../item-card";
import { Item, ItemDataStore, MovementTypes } from '@skinsoft/entity';
import { Form } from '../../form';
import { Field } from '../../field';
import { first } from 'rxjs/operators';

export interface Values {
    location: string;
    identifier: string
}

@Component({
    components: {
        sBarcodeReader: BarcodeReader,
        sBarcodeSubscriber: BarcodeSubscriber,
        sItemCard: ItemCard
    },
    template: require('./add-accessory-form.html')
})
export class AddAccessoryForm extends ReactiveVue {
    public onSubmit: Config['onSubmit']
    public accessory: Item = null as any
    public canChainAdd: boolean

    public MovementTypes = MovementTypes

    public $refs: {
        barcodeReader: BarcodeReader
        form: Form
        location: Field
    }

    private searchPending = false
    private debounce = debounce
    private $itemDataStore: ItemDataStore
    private errorMessage: string = ''
    private submitting: boolean = false

    private readonly INPUT_FILTER_IDENTIFIER: string = 'add-item-search-query-input'

    private undoIcon = faUndo
    private loadingIcon = faCircleNotch

    public async validate(values): Promise<any> {
        const errors = {} as any
        const errorMessage = this.$t('entity.addItem.form.id.notFoundError') as string

        if (!values.id) {
            this.errorMessage = this.$t('entity.addItem.from.id.emptyError') as string
        }

        if (values.id) {
            try {
                this.searchPending = true
                const matchingSearchResult = await this.$itemDataStore.searchOneWithText(values.id, ['physicalAccessoryItem', 'numericAccessoryItem'])
                const searchResultId = ItemDataStore.getItemSearchResultId(matchingSearchResult)

                this.accessory = await this.$itemDataStore.fetchOne(searchResultId).pipe(first()).toPromise()
                const form = this.$refs.form.form
                // @ts-ignore
                form.getState().values.itemId = this.accessory.id
                // @ts-ignore
                form.getState().values.itemType = this.accessory.type
                
                this.searchPending = false
            } catch(error) {
                this.searchPending = false
                this.errorMessage = errorMessage
                this.accessory = null as any
            }
        }

        return errors
    }

    public onBarcodeReaderInput(input: string) {
        const form = this.$refs.form.form

        form.batch(() => {
            const fieldName = 'id'
            form.change(fieldName, input)
            form.mutators.setFieldTouched(fieldName, true)
        })
    }

    public resetSearch() {
        this.accessory = null as any
        const form = this.$refs.form.form
        const fieldName = 'id'
        form.change(fieldName, '')
        form.mutators.setFieldTouched(fieldName, true)
        this.searchPending = false
    }

    private validateSelection() {
        this.$emit('accessory-selected', this.accessory)
        if (this.canChainAdd) {
            this.resetSearch()
        } else {
            this.submitting = true
        }
    }
}